module.exports = [
	{
		"match": "sound",
		"title": "Making a Mobile App?",
		"content": "Find some great SFX for your new game or app?  Be sure to check out our <a href=\"https://codecanyon.net/category/mobile\">Android and iOS mobile templates</a> over on CodeCanyon as well. ",
		"button_label": "Browse Mobile Templates",
		"icon_source": "robot_v1.png",
		"link": "https://codecanyon.net/category/mobile"
	},
	{
		"match": [
			"logos-idents",
			"music",
			"music-packs"
		],
		"title": "Media Players",
		"content": "Embed music and videos directly into your website with these cutting-edge <a href=\"https://codecanyon.net/category/html5/media\">HTML5 media players</a> on CodeCanyon. ",
		"button_label": "Browse Media Players",
		"icon_source": "games_v1.png",
		"link": "https://codecanyon.net/category/html5/media"
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/ads/audiojungle.json
// module id = 622
// module chunks = 1